export default __webpack_public_path__ + "static/media/Example.77a7888a.jpg";